import { i18n } from '../plugins/i18n'

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export function applyAverages(fields, averages, priceFormatter) {
  fields.list.forEach(field => {
    if (
      (field.group !== 'price_per_km' &&
        field.group !== 'return_price_per_km') ||
      field.attribute.endsWith('.price')
    ) {
      return
    }

    if (averages[field.group] && averages[field.group][field.initialValue]) {
      fields.byAttribute[
        field.attribute.replace('.km', '.price')
      ].helpText = i18n.t('company.average_price', {
        price: priceFormatter(averages[field.group][field.initialValue]),
      })
    } else {
      fields.byAttribute[field.attribute.replace('.km', '.price')].helpText = ''
    }
  })
}
